<form #dateFilterForm="ngForm" class="filter-row start-center flex-row">
    <cb-datepicker
        label="Date From"
        name="dateFrom"
        [(ngModel)]="dateFrom"
        (change)="cleanSearch()"
    ></cb-datepicker>
    <cb-datepicker
        label="Date To"
        name="dateTo"
        [(ngModel)]="dateTo"
        (change)="cleanSearch()"
    ></cb-datepicker>
    <mat-icon> search </mat-icon>
    <mat-form-field class="flex">
        <mat-label>Search Logs</mat-label>
        <input
            type="text"
            aria-label="Search Exception Logs"
            [formControl]="searchText"
            name="logsSearch"
            matInput
        />
    </mat-form-field>
    <button [matMenuTriggerFor]="menu" mat-icon-button>
        <mat-icon> more_horiz </mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="reindexLogs()">Fetch Latest Logs</button>
    </mat-menu>
</form>
<div class="chips-container flex-col">
    <mat-chip-set>
        <mat-chip (removed)="clearFilters()">
            <strong class="mat-body-2"> Clear All Filters </strong>
            <button matChipRemove>
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip>
        @if (dateFrom != null) {
            <mat-chip (removed)="clearDateFrom()">
                <strong class="mat-body-2"> Date From - {{ dateFrom | date }} </strong>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
        }
        @if (dateTo != null) {
            <mat-chip (removed)="clearDateTo()">
                <strong class="mat-body-2"> Date To - {{ dateTo | date }} </strong>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
        }
        @if (!isNullOrWhiteSpace(searchText.value)) {
            <mat-chip (removed)="searchText.setValue('')">
                <strong class="mat-body-2"> Query - {{ searchText.value }} </strong>
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
        }
    </mat-chip-set>
</div>
<cb-table
    class="cb-margin-top flex"
    maxHeightOffset="312"
    [objectColumns]="columns"
    [loaded]="true"
    [fetch]="search()"
    [queryUpdated]="queryUpdated"
    [infiniteScrollEnabled]="infiniteScrollEnabled"
    [(results)]="logs"
    [(currentPage)]="currentPage"
>
    @for (element of logs; track element) {
        <tr cbTableRow>
            <cb-td-text [value]="element.eventDate | date: 'dd/MM/yyyy HH:mm:ss'"></cb-td-text>
            <cb-td-text [value]="element.instanceId"></cb-td-text>
            <cb-td-text [value]="element.instancePrivateIp"></cb-td-text>
            <cb-td-text [value]="element.source"></cb-td-text>
            <cb-td-text [value]="element.logError || element.eventMessage"></cb-td-text>
            <td cbTableShrinkCol cbTableStickyCol="end">
                <button mat-icon-button (click)="viewExceptionLog(element)">
                    <mat-icon> help_outline </mat-icon>
                </button>
            </td>
        </tr>
    }
</cb-table>
